<form [formGroup]="form">
  <mat-form-field appearance="outline">
    @if (!hideLabel) {
      <mat-label>
        @if (!autoTranslate) {
          <span>{{labelName}}</span>
        }
        @if (autoTranslate) {
          <mwp-text-translate [text]="labelName" [jsonKey]="labelName" />
        }
      </mat-label>
    }
    <mat-select [formControlName]="nameForControl" >
      @for (item of dataEnum | enumKeys; track item) {
        <mat-option [value]="item.key" (onSelectionChange)="onChange($event)">
          {{item.value}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>